import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  PayoutMethodType,
  PayoutSliceType,
} from "containers/PayoutManagement/types";

const initialState: PayoutSliceType = {
  payoutMethod: null,
};

export const payoutSlice = createSlice({
  name: "payout",
  initialState,
  reducers: {
    setPayoutMethods: (
      state: PayoutSliceType,
      action: PayloadAction<PayoutMethodType | null>
    ) => {
      state.payoutMethod = action.payload;
    },
  },
});

export const { setPayoutMethods } = payoutSlice.actions;
export default payoutSlice.reducer;
